import {createApp} from 'vue'
import StafetDeltagSomFighterStepThree from './StafetDeltagSomFighterStepThree'

const el = '.kb-component--stafet-deltag-som-fighter-step-three'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((StafetDeltagSomFighterStepThreeDOM)=>{
            const component = createApp(StafetDeltagSomFighterStepThree).use(Store)
            component.mount(StafetDeltagSomFighterStepThreeDOM)
        })
    }
}